/**
 * Product Add to Cart Handler - Optimized
 * Style: Palace-inspired
 * @version 2.0.0
 */

class ProductAddToCart {
  constructor() {
    this.form = document.getElementById('AddToCartForm');
    this.addToCartBtn = document.getElementById('AddToCart');
    this.addToCartText = document.getElementById('AddToCartText');
    this.priceElement = document.getElementById('ProductPrice');
    this.comparePriceElement = document.getElementById('ComparePrice');
    this.variantSelector = document.getElementById('ProductSelect-' + this.getSectionId());

    if (this.form) {
      this.init();
    }
  }

  init() {
    // Handle form submission
    this.form.addEventListener('submit', this.handleSubmit.bind(this));

    // Handle variant change
    if (this.variantSelector) {
      this.variantSelector.addEventListener('change', this.handleVariantChange.bind(this));
    }

    // Handle image clicks for thumbnails
    this.initThumbnailClick();

    // Handle technical details tabs
    this.initTabs();
  }

  getSectionId() {
    const section = document.getElementById('ProductSection');
    return section ? section.dataset.sectionId : '';
  }

  async handleSubmit(e) {
    e.preventDefault();

    // Add loading state
    this.addToCartBtn.disabled = true;
    this.addToCartBtn.classList.add('is-loading');
    this.addToCartText.textContent = 'ADDING...';

    const formData = new FormData(this.form);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();

      // Success!
      this.addToCartText.textContent = 'ADDED!';
      this.addToCartBtn.classList.remove('is-loading');

      this.showNotification('✓ Product added to cart!');
      this.updateCartCount();

      // Reset button after 2 seconds
      setTimeout(() => {
        this.addToCartBtn.disabled = false;
        this.addToCartText.textContent = 'ADD TO CART';
      }, 2000);

    } catch (error) {
      console.error('Error:', error);
      this.addToCartText.textContent = 'ADD TO CART';
      this.addToCartBtn.disabled = false;
      this.addToCartBtn.classList.remove('is-loading');
      this.showNotification('❌ Error adding to cart', 'error');
    }
  }

  handleVariantChange(e) {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const variantId = selectedOption.value;

    // Get variant data from JSON
    this.updateProductInfo(variantId);

    // Update button state
    if (selectedOption.disabled) {
      this.addToCartBtn.disabled = true;
      this.addToCartText.textContent = 'SOLD OUT';
    } else {
      this.addToCartBtn.disabled = false;
      this.addToCartText.textContent = 'ADD TO CART';
    }
  }

  async updateProductInfo(variantId) {
    try {
      const productData = this.getProductJson();
      const variant = productData.variants.find(v => v.id == variantId);

      if (variant) {
        // Update price
        if (this.priceElement) {
          this.priceElement.textContent = this.formatMoney(variant.price);
        }

        // Update compare price
        if (this.comparePriceElement && variant.compare_at_price) {
          this.comparePriceElement.textContent = this.formatMoney(variant.compare_at_price);
          this.comparePriceElement.classList.remove('hide');
        } else if (this.comparePriceElement) {
          this.comparePriceElement.classList.add('hide');
        }

        // Update featured image if variant has one
        if (variant.featured_image) {
          this.updateFeaturedImage(variant.featured_image.id);
        }
      }
    } catch (error) {
      console.error('Error updating product info:', error);
    }
  }

  getProductJson() {
    const scriptTag = document.getElementById('ProductJson-' + this.getSectionId());
    return scriptTag ? JSON.parse(scriptTag.textContent) : null;
  }

  updateFeaturedImage(imageId) {
    // Hide all images
    const imageWrappers = document.querySelectorAll('.product-single__image-wrapper');
    imageWrappers.forEach(wrapper => {
      wrapper.classList.add('hide');
    });

    // Show selected image
    const selectedWrapper = document.querySelector(`[data-image-id="${imageId}"]`);
    if (selectedWrapper) {
      selectedWrapper.classList.remove('hide');
    }
  }

  initThumbnailClick() {
    const thumbnails = document.querySelectorAll('.product-single__thumbnail');

    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        const imageId = thumb.dataset.imageId;
        this.updateFeaturedImage(imageId);

        // Update active state on thumbnails
        thumbnails.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  showNotification(message, type = 'success') {
    // Remove existing notifications
    const existing = document.querySelector('.cart-notification');
    if (existing) {
      existing.remove();
    }

    const notification = document.createElement('div');
    notification.className = `cart-notification cart-notification--${type}`;
    notification.textContent = message;
    document.body.appendChild(notification);

    // Auto remove after 3 seconds
    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
      setTimeout(() => notification.remove(), 400);
    }, 3000);
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const cartCountElements = document.querySelectorAll('.cart-count, .cart-link__bubble, [data-cart-count]');

      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;

        // Add animation
        element.classList.add('cart-count--updated');
        setTimeout(() => {
          element.classList.remove('cart-count--updated');
        }, 600);
      });

    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  formatMoney(cents) {
    // Simple money formatter - adapt to your currency
    const amount = (cents / 100).toFixed(2);
    return `€${amount}`;
  }

  initTabs() {
    // Gérer les onglets Technical Details et Size Chart
    const tabTriggers = document.querySelectorAll('[data-tab-trigger]');

    tabTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();

        const tabId = trigger.getAttribute('data-tab-trigger');

        // Désactiver tous les onglets
        tabTriggers.forEach(t => t.classList.remove('is-active'));
        document.querySelectorAll('.product-tab-content').forEach(content => {
          content.classList.remove('is-active');
        });

        // Activer l'onglet cliqué
        trigger.classList.add('is-active');
        const tabContent = document.getElementById(tabId);
        if (tabContent) {
          tabContent.classList.add('is-active');

          // Smooth scroll vers le contenu
          tabContent.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductAddToCart();
  });
} else {
  new ProductAddToCart();
}

// Add slideOutRight animation
const style = document.createElement('style');
style.textContent = `
  @keyframes slideOutRight {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(450px);
      opacity: 0;
    }
  }

  .cart-count--updated {
    animation: pulse 0.6s ease;
  }

  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
  }

  .cart-notification--error {
    background: #ff0000 !important;
  }
`;
document.head.appendChild(style);
